import {Cureus} from '../Cureus';

Cureus.EditorArticleRating= {};

//= require_tree ./EditorArticleRating
